// Chakra imports
import {Box, SimpleGrid} from "@chakra-ui/react";
import React from "react";
import UserListing from "../pages/UserListing.tsx";

export default function UserList() {
    // Chakra Color Mode
    return (
        <Box pt={{base: "130px", md: "80px", xl: "80px"}}>
            <SimpleGrid
                mb='20px'
                columns={{sm: 1, md: 0}}
                spacing={{base: "20px", xl: "20px"}}>
                <UserListing/>
            </SimpleGrid>
        </Box>
    );
}
